export const navigation = [
  {
    name: "summary",
  },
  {
    name: "route",
  },
  {
    name: "checklist",
  },
  {
    name: "weather",
  },
  {
    name: "survey",
  },
  {
    name: "links",
  },
  {
    name: "pictures",
  },
  {
    name: "videos",
  },
  {
    name: "partners",
  },
  {
    name: "faq",
  },
  {
    name: "comments",
  },
];
